import { Component, inject, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MCConfigService, MCFormisForm, MCFormValidationService } from "@maslul/common-services";
import { MCButtonComponent, MCFieldFormComponent } from "@maslul/common-components";
import { GeneralDetailsService } from "../../../../../services/pages/general-details/general-details";
import { Subscription } from "rxjs";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { ReactiveFormsModule } from "@angular/forms";
import { DialogModule } from 'primeng/dialog';
import cloneDeep from "clone-deep";
import { GeneralDetailsStore } from "../../../../../services/store/general-details";
import { TranslateService } from "@ngx-translate/core";
import { GeneralSkeletonComponent } from "../../components/general-skeleton/general-skeleton";
import { PageBaseComponent } from "../../../../shared/page-base";
import { FocusOnTabDirective } from "../../../../../services/shared/directives/focus-on-tab";
import { ProductsService } from "../../../../../services/pages/products/products";

@Component({
    selector: 'mi-general-details',
    imports: [
        MCFieldFormComponent,
        ReactiveFormsModule,
        FormlyModule,
        MCButtonComponent,
        DialogModule,
        GeneralSkeletonComponent,
        FocusOnTabDirective
    ],
    templateUrl: './general-details.html',
    styleUrl: './general-details.scss',
    encapsulation: ViewEncapsulation.None
})
export class GeneralDetailsComponent extends PageBaseComponent implements OnInit, OnDestroy {

    private translateService = inject(TranslateService);
    private generalDetailsService = inject(GeneralDetailsService);
    private generalDetailsStore = inject(GeneralDetailsStore);
    private formValidationService = inject(MCFormValidationService);
    private productService = inject(ProductsService);
    private configService = inject(MCConfigService);


    formisForm: MCFormisForm = new MCFormisForm();
    subscription: Subscription = new Subscription();
    displaySuccessDialog: boolean = false;
    tabsText = toSignal(this.translateService.stream('tabs'));
    genericText = toSignal(this.translateService.stream('generic'));


    ngOnInit() {
        this.initFormisForm();
    }


    initFormisForm() {
        this.formisForm.options = {};//formState from store
        //this.formisForm.form = new FormGroup({});
        this.formisForm.model = cloneDeep(this.generalDetailsStore.getSnapshot().formisFormModel);
        this.initFields();


    }

    initFields() {
        this.subscription.add(
            this.generalDetailsService.getFields(this.formisForm)
                .subscribe((formisFormFields: Array<FormlyFieldConfig> | undefined) => {
                    if (formisFormFields) {
                        this.formisForm.fields = formisFormFields;
                    }
                }))
            ;
    }


    back() {
        this.generalDetailsStore.setFormisFormModel(cloneDeep(this.formisForm.model));
        this.navigate('applicant-details')
    }


    next() {
        const isValid = this.formisForm.form.valid;

        this.generalDetailsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        if (isValid || this.configService.getConfiguration().noValidCheck == "true" || (!this.isNewRequest && this.requestId)) {


            this.generalDetailsService.saveFormState(cloneDeep(this.formisForm.model));
            this.productService.nextToProductTab();

        }
        else {
            this.formisForm.form.markAllAsTouched();
            const invalidFields = this.formValidationService.getInvalidControlsFlatMap(this.formisForm.form);
            console.log('generalDetails get invalid field', invalidFields);


        }
    }


    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}